import { useEffect, useState } from "react";
import { endpoints, API_BASE } from "@/lib/api";
import { AdSlot } from "@/components/AdSlot";

const abs = (u) => (u && u.startsWith("/api/") ? `${API_BASE}${u}` : u);

// Admin-managed homepage video (streamed + lazy) and the homepage ad slot.
export const HomepageVideo = () => {
  const [hp, setHp] = useState({ active: false });

  useEffect(() => { endpoints.homepageMedia().then((r) => setHp(r.data || { active: false })).catch(() => {}); }, []);

  return (
    <>
      {hp.active && hp.url && (
        <div className="w-full bg-black" data-testid="homepage-video">
          <div className="max-w-7xl mx-auto">
            {hp.type === "video"
              ? <video src={abs(hp.url)} poster={abs(hp.poster)} autoPlay muted loop playsInline preload="metadata"
                  className="w-full max-h-[70vh] object-cover" />
              : <img src={abs(hp.url)} alt="" className="w-full max-h-[70vh] object-cover" loading="eager" />}
          </div>
        </div>
      )}
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto"><AdSlot placement="home" position="top" className="mt-6" /></div>
    </>
  );
};
